import { Naslov } from "../../../index";

const Index = () => {
  return (
    <>
      <Naslov label={"Uloga (Role)"} />
      <span>Operater platforme</span>
    </>
  );
};

export default Index;
